import { call, put, takeLatest } from 'redux-saga/effects';
import SynchroApi, {
  FindSynchroLogResponseItem,
  synchroHistoryRequestMap,
} from '../../services/SynchroApi';
import {
  FIND_SYNCHRO_HISTORY_REQUESTED,
  EXECUTE_SYNCHRO_REQUESTED,
  FindSynchroHistoryRequestedAction,
  ExecuteSynchroRequestedAction,
} from './types';
import {
  findSynchroHistorySucceeded,
  findSynchroHistoryFailed,
  executeSynchroSucceeded,
  executeSynchroFailed,
  findSynchroHistoryRequested,
} from './actionCreators';
import { enqueueNotification } from '../notifications/actionCreators';
import { SynchroLogItem } from '../../components/SynchroDataGrid/handlerFactory';

const mapResponseToUi = (data: FindSynchroLogResponseItem[]): SynchroLogItem[] => {
  if (!data || !Array.isArray(data)) return [];

  return data.map((item: FindSynchroLogResponseItem): SynchroLogItem => {
    const isSent = item.sent === 'Y' || item.sent === 'S';

    return {
      country: item.country || '',
      store: item.store || '',
      accountingDateFrom: item.accounting_date || '',
      accountingDateTo: item.accounting_date || '',
      justification: item.justification || '',
      executionDate: item.created_date || '',
      status: isSent ? 'SENT' : 'PENDING',
      user: item.created_by || '',
      message: item.message ?? undefined,
      sent: isSent ? 'S' : 'N',
    };
  });
};

function* findSynchroHistory(action: FindSynchroHistoryRequestedAction) {
  try {
    const { data, status } = yield call(SynchroApi.findSynchroHistory, action.payload);
    if (action.payload.isSentToOnedrive && status === 202) {
      yield put(findSynchroHistorySucceeded([]));
      yield put(
        enqueueNotification({
          key: 'sendOnedriveSuccess',
          message: t => t('shared.messages.sendToOnedrive') || 'Solicitud enviada a OneDrive',
          variant: 'success',
        })
      );
      return;
    }
    const uiData = mapResponseToUi(data);
    yield put(findSynchroHistorySucceeded(uiData));
  } catch (error: any) {
    console.error('Error fetching history:', error);
    yield put(findSynchroHistoryFailed(error));
  }
}

function* executeSynchro(action: ExecuteSynchroRequestedAction) {
  try {
    yield call(SynchroApi.executeSynchro, action.payload);

    yield put(executeSynchroSucceeded());

    yield put(
      enqueueNotification({
        key: 'executeSynchroSuccess',
        message: t =>
          t('synchro4me.messages.executionSuccess') || 'Sincronización iniciada con éxito',
        variant: 'success',
      })
    );

    const refreshFilter = {
      countryAcronym: action.payload.countryAcronym,
      stores: action.payload.stores,
      dateFrom: action.payload.businessDateFrom,
      dateTo: action.payload.businessDateTo,
    };

    yield put(findSynchroHistoryRequested(refreshFilter));
  } catch (error: any) {
    console.error('Error executing synchro:', error);
    yield put(executeSynchroFailed(error));

    yield put(
      enqueueNotification({
        key: 'executeSynchroError',
        message: t =>
          t('synchro4me.messages.executionError') || 'Error al iniciar la sincronización',
        variant: 'error',
      })
    );
  }
}

export default [
  takeLatest(FIND_SYNCHRO_HISTORY_REQUESTED, findSynchroHistory),
  takeLatest(EXECUTE_SYNCHRO_REQUESTED, executeSynchro),
];
